/** Beta Extensions */
export const EXT_BETA_TICKET_LOCATIONS = "beta-ticketLocations";
export const EXT_BETA_POLICY = "beta-policy";
export const EXT_BETA_GENERAL_INFO = "beta-generalInfo";
export const EXT_BETA_AVAILABILITY_PRICING_TYPE = "beta-availabilityPricingType";
export const EXT_BETA_TRAVELER_WEIGHT = "beta-weight";
export const EXT_BETA_TICKET_START_DATE = "beta-ticketStartDate";
export const EXT_BETA_TICKET_END_DATE = "beta-ticketEndDate";
export const EXT_BETA_CATEGORIES = "beta-categories";

export const CONTENT_FEATURE_BOOKING_TERMS = "BOOKING_TERMS_AND_CONDITIONS";
export const CONTENT_FEATURE_CANCELLATION_TERMS = "CANCELLATION_TERMS_AND_CONDITIONS";

/** Disney Specific Extensions */
export const EXT_DISNEY_SALES_START_DATE = "disney-salesStartDate";
export const EXT_DISNEY_SALES_END_DATE = "disney-salesEndDate";
export const EXT_DISNEY_USAGE_START_DATE = "disney-usageStartDate";
export const EXT_DISNEY_USAGE_END_DATE = "disney-usageEndDate";
export const EXT_DISNEY_TICKET_START_DATE = "disney-ticketStartDate";
export const EXT_DISNEY_TICKET_END_DATE = "disney-ticketEndDate";
export const EXT_DISNEY_PARK_LOCATIONS = "disney-parkLocations";
export const EXT_DISNEY_PARK_RESERVATIONS_REQUIRED = "disney-parkReservationRequired";
export const EXT_DISNEY_PARK_RESERVATION_DATE = "disney-parkReservationDate";
export const EXT_DISNEY_PARK_RESERVATION_STATUS = "disney-parkReservationStatus";
export const EXT_DISNEY_BULK_TICKET_PURCHASE = "disney-bulkTicketPurchase";
export const EXT_DISNEY_BULK_TICKET_DELIVERY_DATE = "disney-deliveryDate";
export const EXT_DISNEY_BULK_TICKET_DELIVERY_INSTRUCTIONS = "disney-deliveryInstructions";
export const EXT_DISNEY_BULK_TICKET_DELIVERY_TYPE = "disney-deliveryType";
export const EXT_DISNEY_DATE_BASED_TICKET = "disney-dateBasedTicket";
export const EXT_DISNEY_DISCOUNT_GROUPS = "disney-discountGroups";
export const EXT_DISNEY_MARKET_REGIONS = "disney-marketRegions";
export const EXT_DISNEY_PRODUCT_DURATION = "disney-productDuration";
export const EXT_DISNEY_BOOKING_BUFFER_DAYS = "disney-bookingBufferDays";
export const EXT_DISNEY_DISTRIBUTOR_NAME = "disney-distributorName";
export const EXT_DISNEY_NET_DISCOUNT = "disney-netDiscount";

/** Reseller Portal Specific Extensions */
export const EXT_RESELLER_PORTAL_AGENT_NAME = "x-resellerPortal.AgentName";
export const EXT_RESELLER_PORTAL_AGENT_EMAIL = "x-resellerPortal.AgentEmail";
export const EXT_RESELLER_PORTAL_RESELLER_NAME = "x-resellerPortal.ResellerName";
export const EXT_RESELLER_PORTAL_RESELLER_REGION = "x-resellerPortal.ResellerRegion";
export const EXT_RESELLER_PORTAL_PAYMENT_TRANSACTION_ID = "x-ResellerPortal.PaymentTransactionID";
export const EXT_RESELLER_PORTAL_PAYMENT_TOTAL = "x-ResellerPortal.PaymentTotal";
export const EXT_RESELLER_PORTAL_PAYMENT_PROCESSING_FEE = "x-ResellerPortal.PaymentProcessingFee";
export const EXT_RESELLER_PORTAL_PAYMENT_INTENT_ID = "x-ResellerPortal.PaymentIntentID";
export const EXT_RESELLER_PORTAL_PAYMENT_TRANSFER_TOTAL = "x-ResellerPortal.PaymentTransferTotal";
export const EXT_RESELLER_PORTAL_PAYMENT_TRANSFER_BALANCE = "x-ResellerPortal.PaymentTransferBalance";
export const EXT_RESELLER_PORTAL_PAYMENT_TRANSFER_PAYOUT = "x-ResellerPortal.PaymentTransferPayout";
export const EXT_RESELLER_PORTAL_PAYMENT_PRICE_TYPE = "x-ResellerPortal.PaymentPriceType";
export const EXT_RESELLER_PORTAL_SUPPLIER_SALES_TYPE = "x-ResellerPortal.SupplierSalesType";
export const EXT_RESELLER_PORTAL_PAYMENT_CART_ID = "x-ResellerPortal.PaymentCartID";
export const EXT_RESELLER_PORTAL_PAYMENT_MERCHANT_OF_RECORD = "x-ResellerPortal.PaymentMerchantOfRecord";
export const EXT_RESELLER_PORTAL_EXPERIENCE_SEARCH_BOOKING = "x-ResellerPortal.ExperienceSearchBooking";

/* Ticketmaster Extensions */
export const EXT_TICKETMASTER_TICKET_LIMIT = "ticketmaster.CurrentTicketLimit";

/** others */
export const EXT_TICKETING_SYSTEM = "x-ticketingSystem";
export const EXT_SUPPLIER_REFERENCE = "supplier.reference";
